import { withAlpha, useAccentFn } from "@/lib/color";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

const TROPHY_IMAGES = {
    TOP: "/trophies/campionato-top.webp",
    DOP: "/trophies/campionato-dop.webp",
    OPS: "/trophies/campionato-ops.webp",
    HOPE: "/trophies/campionato-hope.webp",
    PRIMAVERA: "/trophies/campionato-primavera.webp",
};

export default function Campionati() {
    const [divisions, setDivisions] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/divisions");
                setDivisions(data || []);
            } catch (e) {
                console.error(e);
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="campionati-page">
            <div className="op-label" style={{ color: "rgb(var(--tc-ff7a1a))" }}>// COMPETIZIONI</div>
            <h1 className="op-heading text-5xl sm:text-6xl mt-3">
                <span className="op-gradient-text">CAMPIONATI</span>
            </h1>
            <p className="text-t8f95a3 text-sm mt-3 max-w-2xl">
                Le 4 leghe del torneo. Clicca su una divisione per vedere la classifica.
                Stagione 25 — punti a zero, pronti per la partenza.
            </p>

            {loading ? (
                <div className="op-label text-t8f95a3 animate-pulse mt-10">// CARICAMENTO…</div>
            ) : (() => {
                const main = divisions.filter((d) => d.code !== "PRIMAVERA");
                const prim = divisions.find((d) => d.code === "PRIMAVERA");
                return (
                    <div className="mt-10 space-y-10">
                        <div>
                            <div className="op-label mb-3">// PRIMA SQUADRA</div>
                            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
                                {main.map((d) => (
                                    <DivisionCard key={d.code} division={d} />
                                ))}
                            </div>
                        </div>
                        {prim && (
                            <div>
                                <div className="op-label mb-3" style={{ color: "rgb(var(--tc-7c3aed))" }}>// SETTORE GIOVANILE</div>
                                <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
                                    <DivisionCard division={prim} />
                                </div>
                            </div>
                        )}
                    </div>
                );
            })()}
        </div>
    );
}

function DivisionCard({ division: d }) {
    const accent = useAccentFn()(d.accent_color);
    const trophy = TROPHY_IMAGES[d.code];

    return (
        <Link
            to={`/campionati/${d.code}`}
            className="op-card relative block overflow-hidden p-0 transition-all duration-300 hover:scale-[1.02] hover:border-t2bb6ff group"
            style={{ borderTop: `4px solid ${accent}` }}
            data-testid={`division-card-${d.code}`}
        >
            {/* Trophy showcase area */}
            <div
                className="relative aspect-[4/5] flex items-center justify-center overflow-hidden"
                style={{
                    background: `radial-gradient(ellipse at center, ${withAlpha(accent, "30")} 0%, ${withAlpha(accent, "08")} 40%, rgb(var(--tc-0a0b0e)) 100%)`,
                }}
            >
                <div
                    aria-hidden
                    className="absolute inset-0 pointer-events-none"
                    style={{
                        background: `radial-gradient(circle at center, ${withAlpha(accent, "50")} 0%, transparent 55%)`,
                        filter: "blur(20px)",
                        opacity: 0.5,
                    }}
                />
                <div
                    aria-hidden
                    className="absolute inset-0 pointer-events-none opacity-30"
                    style={{
                        background: `linear-gradient(135deg, transparent 30%, ${withAlpha(accent, "22")} 50%, transparent 70%)`,
                    }}
                />
                {trophy ? (
                    <img
                        src={trophy}
                        alt={`Trofeo ${d.name}`}
                        loading="lazy"
                        className="relative z-10 max-h-[88%] max-w-[78%] object-contain drop-shadow-[0_8px_30px_rgba(0,0,0,0.65)] group-hover:scale-105 transition-transform duration-500"
                        style={{ filter: `drop-shadow(0 0 18px ${withAlpha(accent, "66")})` }}
                    />
                ) : (
                    <div className="op-heading text-6xl relative z-10" style={{ color: accent, opacity: 0.4 }}>
                        {d.code}
                    </div>
                )}
                <div className="absolute inset-x-0 bottom-0 h-24 pointer-events-none bg-gradient-to-t from-t0a0b0e to-transparent" />
            </div>

            {/* Info footer */}
            <div className="relative p-5 border-t border-t22252a bg-t0a0b0e">
                <div className="flex items-center justify-between mb-2">
                    <div className="op-label" style={{ color: accent }}>
                        DIVISIONE #{d.order}
                    </div>
                    <div className="op-mono text-xs text-t8f95a3">14 squadre</div>
                </div>
                <div className="op-heading text-2xl leading-tight" style={{ color: accent }}>
                    {d.name}
                </div>
                <p className="text-xs text-tc9ccd3 mt-2 leading-relaxed line-clamp-2">
                    {d.description}
                </p>
                <div className="op-mono text-[10px] text-t5c6370 mt-3 uppercase">
                    → vedi classifica
                </div>
            </div>
        </Link>
    );
}
